export const CARD_STATE = {
  LOADING: 'loading',
  EMPTY: 'info',
  ERROR: 'error',
};
